/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import Evolution, { IEvolution } from '../../../components/Evolution/Evolution';

import { Market } from '../../../core/models/overview';

import './OverviewCard.scss';

export interface IOverviewCard {
  config: {
    title: string;
    icon: string;
    evolution: IEvolution;
  };
  market: Market;
  scrollId?: string;
}

export default function OverviewCard({
  config: { title, icon, evolution },
  market,
  scrollId,
}: IOverviewCard): JSX.Element {
  const scrollToElement = (): void => {
    if (scrollId) {
      try {
        // https://robinvdvleuten.nl/blog/scroll-a-react-component-into-view/
        document.getElementById(scrollId)?.scrollIntoView({ behavior: 'smooth' });
      } catch (e) {
        document.getElementById(scrollId)?.scrollIntoView();
      }
    }
  };

  return (
    <div className="OverviewCard" onClick={scrollToElement} role="button" tabIndex={0}>
      <div className="OverviewCard__title fsc">
        <img src={icon} alt="" />
        <h3>{title}</h3>
      </div>
      <div className="OverviewCard__evolution">
        <Evolution
          arrow={market.arrow}
          price={market.marketValue}
          origin={evolution.origin}
          currency={evolution.currency}
          decimals={evolution.decimals}
        />
      </div>
    </div>
  );
}
